import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	gap: 50px;
`;
export const ClientData = styled.div`
	flex: 1 1 80%;
`;
